import Cookies from 'js-cookie'

export const USER_SESSION_KEY = 'pms_celebration_user'

export const getStoredUser = () => {
    try {
        const raw = sessionStorage.getItem(USER_SESSION_KEY)
        return raw ? JSON.parse(raw) : null
    } catch {
        return null
    }
}

export const storeUser = (user) => {
    if (user) {
        sessionStorage.setItem(USER_SESSION_KEY, JSON.stringify(user))
    }
}

export const clearStoredUser = () => {
    sessionStorage.removeItem(USER_SESSION_KEY)
}

export const clearAuthToken = () => {
    Cookies.remove('token')
    Cookies.remove('refresh')
}

export const persistAuth = (data) => {
    const token = data?.token || data?.access || data?.tokens?.access
    const refresh = data?.refresh || data?.tokens?.refresh

    if (token) {
        Cookies.set('token', token, { expires: 7 })
    }
    if (refresh) {
        Cookies.set('refresh', refresh, { expires: 7 })
    }
    if (data?.user) {
        storeUser(data.user)
    }
}

export const signOut = () => {
    clearAuthToken()
}

export const getDashboardForRole = (role) => {
    switch ((role || '').toString().toLowerCase()) {
        case 'hr':
            return '/hr/dashboard'
        case 'supervisor':
        case 'hod':
            return '/hod/dashboard'
        case 'coo':
            return '/coo/dashboard'
        case 'cos':
            return '/cos/dashboard'
        case 'employee':
            return '/employee/dashboard'
        default:
            return null
    }
}

export const getUserDisplayName = (user) => {
    if (!user) return 'User'
    const name = [user.full_name].filter(Boolean).join(' ').trim()
    const role = [user.role_display].filter(Boolean).join(' ').trim()
    return name || user.email || 'User'
}

export const getUserSchoolId = (user) => {
    if (!user) return null
    if (typeof user.school === 'number') return user.school
    if (typeof user.school === 'string' && user.school.trim()) {
        const parsed = Number(user.school)
        return Number.isNaN(parsed) ? user.school : parsed
    }
    if (user.school_id) return user.school_id
    if (user.school?.id) return user.school.id
    return null
}

export const getUserSchoolName = (user) => {
    if (!user) return null
    if (typeof user.school === 'object' && user.school?.name) return user.school.name
    if (user.school_name) return user.school_name
    return null
}
